<template>
  <v-layout v-if="!$store.state.navigation.pageLoader">
    <v-layout v-if="loadingData" row justify-center  style="width: 100%;">
      <v-progress-circular
        :size="150"
        :width="7"
        color="blue"
        indeterminate
      ></v-progress-circular>
    </v-layout>
    <v-layout v-else row wrap style="width: 100%;">
      <v-flex sx12>
        <v-data-table
          class="no-action-table default-custom-table history-custom-table"
          :headers="headers"
          :items="history"
          item-key="id"
          :pagination.sync="pagination"
          :total-items="total"
          :loading="loading"
          hide-actions
          v-show="!loadingData"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ $moment(props.item.created_at).format('DD-MM-YYYY, HH:mm') }}</td>
            <td>{{ props.item.description }}</td>
            <td class="text-xs-center">
              <span v-if="props.item.invoice">
                {{ Number((props.item.invoice.invoice_sum_to_bill).toFixed(2)) }} {{ currencySign[props.item.transactions[0].currency_id] }}
              </span>
            </td>
            <td class="text-xs-center">{{ Number((props.item.invoice ? props.item.invoice.purchase_sum : props.item.transactions[0].amount).toFixed(2))}} {{currencySign[props.item.transactions[0].currency_id]}}</td>
            <td  class="text-xs-center">
              <v-chip
                class="pointer white--text"
                color="info"
                label
                small
                @click="selected = props.item; invoiceDialog = true"
              >
                <v-icon class="mr-2" style="font-size: 16px;">visibility</v-icon>View details
              </v-chip>
              <v-btn
                v-if="props.item.invoice"
                flat
                class="chip-action-btn white--text"
                :loading="loading"
                :disabled="loading"
                @click="downloadInvoice(props.item.invoice.invoice_id)"
                v-tooltip.top-center="{
                  content: 'Download Invoice',
                  trigger: $store.state.metadata.windowWidth > 600 ? 'hover' : 'click'
                }"
              >
                <v-chip class="custom-action-chip" label text-color="white" color="info">
                  <v-icon>get_app</v-icon>
                </v-chip>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">
            <tr>
              <td class="text-xs-center" colspan="8">
                <span>No payment history</span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <ToolbarPagerComponent class="mt-1 pa-3" :pagination="pagination"></ToolbarPagerComponent>
      </v-flex>
    </v-layout>
    <HistoryDetailsModal v-if="invoiceDialog" :invoiceDialog="invoiceDialog" :selected="selected"></HistoryDetailsModal>
  </v-layout>
</template>

<script>

export default {
  name: 'SubscriptionHistoryBody',
  props: ['userId'],
  data () {
    return {
      isAdmin: this.$store.state.user.permissions.is_admin,
      loading: false,
      invoiceDialog: false,
      loadingData: false,
      selected: null,
      currencySign: {
        DOLLARS: '$',
        USD: '$',
        NIS: '₪'
      },
      history: [],
      total: 0,
      page: 1,
      pagination: { sortBy: 'id', descending: true, rowsPerPage: 25 },
      // originQuery: this.$route.query,
      headers: [
        { text: 'Created', value: 'created_at', align: 'middle' },
        { text: 'Description', value: 'op_desc', sortable: false },
        // { text: 'Total sum', value: 'amount', align: 'middle' },
        // { text: 'Type', value: 'op_type', align: 'middle' },
        // { text: 'Sub type', value: 'op_subtype', align: 'middle' }
        { text: 'Billed from card', sortable: false, value: '', align: 'middle' },
        { text: 'Amount', sortable: false, value: '', align: 'middle' },
        { text: 'Action', sortable: false, value: '', align: 'middle' }
      ]
    }
  },
  mounted () {
    // this.getQueryData()
    this.getHistory()
    this.$on('invoiceDialog', (value) => {
      this.invoiceDialog = value
    })
    setTimeout(() => {
      this.addPaginationWatcher()
    }, 1500)
    this.headers = this.headers.filter((header) => {
      let showHeader = true
      if (header.role && (header.role !== this.$store.state.auth.role)) {
        showHeader = false
      }
      return showHeader
    })
  },
  computed: {
    computedPagination: function () {
      return Object.assign({}, this.pagination)
    }
  },
  beforeDestroy () {
    this.$off('invoiceDialog')
  },
  methods: {
    getHistory () {
      this.loading = true
      this.loadingData = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let params = {
        page: page,
        count: rowsPerPage,
        order_by: sortBy,
        direction: (descending) ? 'desc' : 'asc',
        filter_blocks: []
      }
      if (this.isAdmin && this.userId) params.user_id = this.userId
      this.$store.dispatch('GET_TRANSACTIONS', params).then(res => {
        // this.setQueryData()
        this.history = res.data
        this.total = res.total_count
        this.pagination.totalItems = res.total_count
        this.loading = false
        this.loadingData = false
        this.$store.commit('SET_PAGE_LOADER', false)
      }, err => {
        this.loading = false
        this.loadingData = false
        console.log('GET_TRANSACTIONS error', err)
        this.$toasted.show('GET_TRANSACTIONS Error: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    addPaginationWatcher () {
      this.$watch('computedPagination', (newVal, oldVal) => {
        let middleVal = Object.assign({}, oldVal)
        middleVal.totalItems = newVal.totalItems
        // if not only totalItems changes
        if (this.total > 0 && JSON.stringify(middleVal) !== JSON.stringify(newVal)) {
          this.paginationAction = true
          this.getHistory()
        }
      }, { deep: true })
    },
    downloadInvoice (invoiceId) {
      let params = {
        // date: this.$moment().format('YYYY-MM-DD'),
        invoice_id: invoiceId
      }
      this.loading = true
      this.$store.dispatch('EXPORT_INVOICE', params).then(res => {
        this.saveFile(res)
        this.loading = false
        this.$toasted.show('Download will start in few seconds')
      }, err => {
        console.log('EXPORT_INVOICE ERROR', err)
        this.loading = false
        let body = String.fromCharCode.apply(null, new Uint8Array(err.body))
        let errorText = JSON.parse(body).msg
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    saveFile (data) {
      let blob = new Blob([data], {type: 'application/pdf'})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'kolyom_invoivce.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
    // getQueryData () {
    //   this.updatePaginationFromQuery()
    // },
    // updatePaginationFromQuery () {
    //   this.pagination.page = parseInt(this.originQuery.page) || 1
    //   setTimeout(() => { this.pagination.page = parseInt(this.originQuery.page) || 1 }, 100)
    //   this.pagination.rowsPerPage = parseInt(this.originQuery.size) || 25
    //   this.pagination.sortBy = this.originQuery.sortBy || 'id'
    //   this.pagination.descending = this.originQuery.sortDesc === undefined || this.originQuery.sortDesc === 'desc'
    // },
    // setQueryData () {
    //   let newQuery = {}
    //   let queryData = this.$route.query
    //   if (queryData.page || this.pagination.page !== 1) newQuery.page = this.pagination.page
    //   if (queryData.size || this.pagination.rowsPerPage !== 5) newQuery.size = this.pagination.rowsPerPage
    //   if (this.pagination.sortBy) newQuery.sortBy = this.pagination.sortBy
    //   if (newQuery.sortBy) {
    //     let sortDesc = (this.pagination.descending) ? 'desc' : 'asc'
    //     if (queryData.sortDesc || this.pagination.descending) newQuery.sortDesc = sortDesc
    //   }
    //   if (this.search) newQuery.search = this.search

    //   this.$router.push({query: newQuery})
    // }
  }
}
</script>

<style>
.chip-action-btn {
  margin: 0px;
  padding: 0px;
  min-width: 0px;
}
.v-chip .v-chip__content {
  font-weight:bold;
}
.pointer .v-chip__content {
  cursor: pointer;
}
.history-custom-table {
  width: 100%;
}
.history-custom-table table.v-table thead th:first-child {
  min-width: 145px;
}
@media only screen and (max-width: 600px){
  .history-custom-table table.v-table tbody td {
    padding: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subscriptions/SubscriptionHistoryBody.vue